<template>
  <!-- <ul class="list-group">
    <li @click="$emit('on-detail', t)" role="button" class="list-group-item list-group-item-action d-flex align-items-center bd-0" v-for="(t,i) in tasks" :key="i">
      <img    :src="`${t.cover}?w=40&h=40&mode=crop`" class="rounded-circle img-thumbnail wd-40- ht-40 pd-0-f" />
      <div class="pd-l-10">
        <h6 class="tx-13 tx-color-02 tx-semibold mg-b-0">{{t.lastName}} {{t.firstName}}</h6>
        <span class="d-block tx-11 tx-color-03">{{t.position}}</span>
      </div>
    </li>
  </ul> -->
  <div>
    <div
      class="card card-profile card-event mg-b-30"
      v-for="(task, i) in tasks"
      :key="i"
    >
      <img src="assets/img/covers/4.png" alt class="card-img-top" />
      <div class="card-body tx-13 pd-y-10-f">
        <div :class="`avatar avatar-xxl mt-n80px wd-140 ht-140`">
          <img
            :src="`${task.cover}?w=144&h=144&mode=pad`"
            alt
            class="rounded-circle img-thumbnail border-0 pd-0-f"
          />
        </div>
        <div
          :class="
            `${
              $store.state.app.isMobile ? 'ht-250' : 'ht-140'
            } align-items-start mg-l-150 pd-l-10 pd-t-20`
          "
        >
          <h6>
            <a>{{ task.lastName }} {{ task.firstName }}</a>
          </h6>
          <p class="mg-b-2 text-muted">Газар нэгж: {{ task.depart }}</p>
          <p class="mg-b-2 text-muted">Албан тушаал: {{ task.position }}</p>
          <p class="mg-b-0 text-muted">И-мэйл хаяг: {{ task.email }}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row row-xs">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4" v-for="(t,i) in tasks" :key="i">
        <div class="card card-profile">
          <div class="ht-100 bg-light"></div>
          <div class="card-body tx-13">
            <div>
              <a>
                <div class="avatar avatar-lg"><img    :src="t.cover" class="rounded-circle img-thumbnail" /></div>
              </a>
              <h5><a>{{t.lastName}} {{t.firstName}}</a></h5>
              <p>{{t.position}}</p>
              <button @click="$emit('on-detail', t)" :class="`btn btn-block btn-${$store.state.app.skin.dark ? 'dark' : 'white'}`">Танилцуулга үзэх</button>
            </div>
          </div>
        </div>
    </div>
  </div> -->
</template>

<script>
export default {
  props: {
    tasks: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style></style>
